import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { testNetworkConnectivity } from '../../helpers/offlineApi';
import { setOfflineMode } from '../../redux/actions/local';
import './OfflineToggle.css';

const OfflineToggle = ({ setOfflineMode }) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [isChecking, setIsChecking] = useState(false);

    const checkConnectivity = async () => {
        setIsChecking(true);
        const online = await testNetworkConnectivity();
        setIsOnline(online);
        setOfflineMode(!online);
        setIsChecking(false);
    };

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setOfflineMode(false);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setOfflineMode(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        checkConnectivity();

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, [setOfflineMode]);

    return (
        <div className="offline-toggle" style={{
            display: 'none'
        }}>
        </div>
    );
};

const mapDispatchToProps = {
    setOfflineMode
};

export default connect(null, mapDispatchToProps)(OfflineToggle);
